import { useState } from 'react';
import { Button, Dropdown, DropdownItem } from 'flowbite-react';
import { HiChevronDown } from 'react-icons/hi';

interface CustomSelectDropdownProps {
  options: Array<{ label: string | null; value: string }>;
  label: string;
  onChange: (value: string) => void;
  defaultOption: { label: string };
}

export const CustomSelectDropdown = (props: CustomSelectDropdownProps) => {
  const [selected, setSelected] = useState<{ label: string | null }>(
    props.defaultOption
  );
  const [isOpen, setIsOpen] = useState(false);
  // Проверяем, выбран ли дефолтный элемент
  const isDefaultSelected = selected?.label === props.defaultOption?.label;

  const handleSelect = (option: { label: string | null; value: string }) => {
    setSelected(option);
    props.onChange(option.value);
    setIsOpen(false);
  };

  const handleReset = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setSelected(props.defaultOption);
    props.onChange(props.defaultOption.label);
  };

  return (
    <Dropdown
      label=""
      renderTrigger={() => (
        <Button color="second" className="px-3 py-2">
          {/* Лейбл с выбранным значением */}
          <div className="truncate flex">
            <div className="text-gray-500 mr-1">{props.label}:</div>
            <div className="text-gray-900 mr-1">{selected?.label}</div>
          </div>

          {/* Динамическая иконка */}
          <div className="flex items-center">
            {!isDefaultSelected ? (
              <div onClick={handleReset}>
                {/* <Icon name="x-outline"
                        aria-label="Сбросить выбор"
                        size='10'
                    /> */}
                ✕
              </div>
            ) : (
              <HiChevronDown className="w-5 h-5 text-gray-900" />
            )}
          </div>
        </Button>
      )}
    >
      {/* Список элементов */}

      {props.options.map((option) => (
        <DropdownItem
          key={option.label}
          onClick={() => handleSelect(option)}
          className="text-gray-900"
        >
          <div className="flex items-center">{option.label}</div>
        </DropdownItem>
      ))}
    </Dropdown>
  );
};
